import _MessageBox2 from "element-ui/lib/theme-chalk/message-box.css";
import "element-ui/lib/theme-chalk/base.css";
import _MessageBox from "element-ui/lib/message-box";
import _Checkbox2 from "element-ui/lib/theme-chalk/checkbox.css";
import "element-ui/lib/theme-chalk/base.css";
import _Checkbox from "element-ui/lib/checkbox";
import _Tag2 from "element-ui/lib/theme-chalk/tag.css";
import "element-ui/lib/theme-chalk/base.css";
import _Tag from "element-ui/lib/tag";
import _Popover2 from "element-ui/lib/theme-chalk/popover.css";
import "element-ui/lib/theme-chalk/base.css";
import _Popover from "element-ui/lib/popover";
import _Rate2 from "element-ui/lib/theme-chalk/rate.css";
import "element-ui/lib/theme-chalk/base.css";
import _Rate from "element-ui/lib/rate";
import _DatePicker2 from "element-ui/lib/theme-chalk/date-picker.css";
import "element-ui/lib/theme-chalk/base.css";
import _DatePicker from "element-ui/lib/date-picker";
import _Switch2 from "element-ui/lib/theme-chalk/switch.css";
import "element-ui/lib/theme-chalk/base.css";
import _Switch from "element-ui/lib/switch";
import _Loading2 from "element-ui/lib/theme-chalk/loading.css";
import "element-ui/lib/theme-chalk/base.css";
import _Loading from "element-ui/lib/loading";
import _Cascader2 from "element-ui/lib/theme-chalk/cascader.css";
import "element-ui/lib/theme-chalk/base.css";
import _Cascader from "element-ui/lib/cascader";
import _Radio2 from "element-ui/lib/theme-chalk/radio.css";
import "element-ui/lib/theme-chalk/base.css";
import _Radio from "element-ui/lib/radio";
import _Pagination2 from "element-ui/lib/theme-chalk/pagination.css";
import "element-ui/lib/theme-chalk/base.css";
import _Pagination from "element-ui/lib/pagination";
import _InputNumber2 from "element-ui/lib/theme-chalk/input-number.css";
import "element-ui/lib/theme-chalk/base.css";
import _InputNumber from "element-ui/lib/input-number";
import _Autocomplete2 from "element-ui/lib/theme-chalk/autocomplete.css";
import "element-ui/lib/theme-chalk/base.css";
import _Autocomplete from "element-ui/lib/autocomplete";
import _MenuItemGroup2 from "element-ui/lib/theme-chalk/menu-item-group.css";
import "element-ui/lib/theme-chalk/base.css";
import _MenuItemGroup from "element-ui/lib/menu-item-group";
import _MenuItem2 from "element-ui/lib/theme-chalk/menu-item.css";
import "element-ui/lib/theme-chalk/base.css";
import _MenuItem from "element-ui/lib/menu-item";
import _Submenu2 from "element-ui/lib/theme-chalk/submenu.css";
import "element-ui/lib/theme-chalk/base.css";
import _Submenu from "element-ui/lib/submenu";
import _Menu2 from "element-ui/lib/theme-chalk/menu.css";
import "element-ui/lib/theme-chalk/base.css";
import _Menu from "element-ui/lib/menu";
import _Tooltip2 from "element-ui/lib/theme-chalk/tooltip.css";
import "element-ui/lib/theme-chalk/base.css";
import _Tooltip from "element-ui/lib/tooltip";
import _DropdownItem2 from "element-ui/lib/theme-chalk/dropdown-item.css";
import "element-ui/lib/theme-chalk/base.css";
import _DropdownItem from "element-ui/lib/dropdown-item";
import _DropdownMenu2 from "element-ui/lib/theme-chalk/dropdown-menu.css";
import "element-ui/lib/theme-chalk/base.css";
import _DropdownMenu from "element-ui/lib/dropdown-menu";
import _Dropdown2 from "element-ui/lib/theme-chalk/dropdown.css";
import "element-ui/lib/theme-chalk/base.css";
import _Dropdown from "element-ui/lib/dropdown";
import _TableColumn2 from "element-ui/lib/theme-chalk/table-column.css";
import "element-ui/lib/theme-chalk/base.css";
import _TableColumn from "element-ui/lib/table-column";
import _Table2 from "element-ui/lib/theme-chalk/table.css";
import "element-ui/lib/theme-chalk/base.css";
import _Table from "element-ui/lib/table";
import _CarouselItem2 from "element-ui/lib/theme-chalk/carousel-item.css";
import "element-ui/lib/theme-chalk/base.css";
import _CarouselItem from "element-ui/lib/carousel-item";
import _Carousel2 from "element-ui/lib/theme-chalk/carousel.css";
import "element-ui/lib/theme-chalk/base.css";
import _Carousel from "element-ui/lib/carousel";
import _TabPane2 from "element-ui/lib/theme-chalk/tab-pane.css";
import "element-ui/lib/theme-chalk/base.css";
import _TabPane from "element-ui/lib/tab-pane";
import _Tabs2 from "element-ui/lib/theme-chalk/tabs.css";
import "element-ui/lib/theme-chalk/base.css";
import _Tabs from "element-ui/lib/tabs";
import _FormItem2 from "element-ui/lib/theme-chalk/form-item.css";
import "element-ui/lib/theme-chalk/base.css";
import _FormItem from "element-ui/lib/form-item";
import _Form2 from "element-ui/lib/theme-chalk/form.css";
import "element-ui/lib/theme-chalk/base.css";
import _Form from "element-ui/lib/form";
import _Dialog2 from "element-ui/lib/theme-chalk/dialog.css";
import "element-ui/lib/theme-chalk/base.css";
import _Dialog from "element-ui/lib/dialog";
import _Option2 from "element-ui/lib/theme-chalk/option.css";
import "element-ui/lib/theme-chalk/base.css";
import _Option from "element-ui/lib/option";
import _Select2 from "element-ui/lib/theme-chalk/select.css";
import "element-ui/lib/theme-chalk/base.css";
import _Select from "element-ui/lib/select";
import _Input2 from "element-ui/lib/theme-chalk/input.css";
import "element-ui/lib/theme-chalk/base.css";
import _Input from "element-ui/lib/input";
import _Button2 from "element-ui/lib/theme-chalk/button.css";
import "element-ui/lib/theme-chalk/base.css";
import _Button from "element-ui/lib/button";
import "G:\\webgit\\pc-chitengmall\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "G:\\webgit\\pc-chitengmall\\node_modules\\core-js\\modules\\es.promise.js";
import "G:\\webgit\\pc-chitengmall\\node_modules\\core-js\\modules\\es.object.assign.js";
import "G:\\webgit\\pc-chitengmall\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import VueCropper from 'vue-cropper';
import VueClipboard from 'vue-clipboard2';
import VueLazyload from 'vue-lazyload';
import Vue from 'vue';
import Component from 'vue-class-component';
import { readCookie } from '@/tools/tools';
import Viewer from 'v-viewer';
import DonMessage from '@/tools/message';
import infiniteScroll from 'vue-infinite-scroll';
import App from './App.vue';
import router from './router';
import store from './store/index';
import { QWebChannel } from '@/tools/qwebchannel';
import '@/assets/styles/index.scss';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'viewerjs/dist/viewer.css';
try {
  new QWebChannel(window.qt.webChannelTransport, function (channel) {
    Vue.prototype.webTransport = channel.objects.webTransport;
  });
} catch (_unused) {}
Vue.use(infiniteScroll);
Vue.use(VueLazyload);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
});
Vue.use(VueCropper);
Vue.use(VueClipboard);
Vue.use(_Button);
Vue.use(_Input);
Vue.use(_Select);
Vue.use(_Option);
Vue.use(_Dialog);
Vue.use(_Form);
Vue.use(_FormItem);
Vue.use(_Tabs);
Vue.use(_TabPane);
Vue.use(_Carousel);
Vue.use(_CarouselItem);
Vue.use(_Table);
Vue.use(_TableColumn);
Vue.use(_Dropdown);
Vue.use(_DropdownMenu);
Vue.use(_DropdownItem);
Vue.use(_Tooltip);
Vue.use(_Menu);
Vue.use(_Submenu);
Vue.use(_MenuItem);
Vue.use(_MenuItemGroup);
Vue.use(_Autocomplete);
Vue.use(_InputNumber);
Vue.use(_Pagination);
Vue.use(_Radio);
Vue.use(_Cascader);
Vue.use(_Loading);
Vue.use(_Switch);
Vue.use(_DatePicker);
Vue.use(_Rate);
Vue.use(_Popover);
Vue.use(_Tag);
Vue.use(_Checkbox);
Vue.prototype.$confirm = _MessageBox.confirm;
Vue.prototype.$message = DonMessage;
Vue.prototype.$msgbox = _MessageBox;
Vue.config.productionTip = false;
router.beforeEach(function (to, from, next) {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  if (to.matched.some(function (record) {
    return record.meta.requireAuth;
  })) {
    setTimeout(function () {
      // 判断该路由是否需要登录权限
      if (readCookie('accessToken')) {
        // 判断当前的token是否存在 ； 登录存入的token
        next();
      } else {
        next({
          name: 'login',
          query: {
            redirect: to.fullPath
          }
        });
      }
    }, 100);
  } else {
    next();
  }
});
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');